import { useSelector } from 'react-redux';

import { agencyMode } from 'app/services/env.service';
import { PageContentWrapper } from 'app/components/PageContentWrapper';
import QuestionsAndAnswersCepikForm from 'app/components/QuestionsAndAnswersCepikForm';
import QuestionsAndAnswers from 'app/components/QuestionsAndAnswers/QuestionsAndAnswers';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';

import { QuestionsAndAnswersSectionProps } from './QuestionsAndAnswersSection.interfaces';
import { useStyles } from './QuestionsAndAnswersSection.styles';

function QuestionsAndAnswersSection(props: QuestionsAndAnswersSectionProps) {
  const classes = useStyles();

  const isFormMicroCenterActive = useSelector(selectIsFormMicroCenterActive);

  if (agencyMode) {
    return null;
  }

  return (
    <PageContentWrapper
      className={classes.root}
      mainContent={
        <div className={classes.qa}>
          {isFormMicroCenterActive ? (
            <QuestionsAndAnswersCepikForm />
          ) : (
            <QuestionsAndAnswers />
          )}
        </div>
      }
    />
  );
}

export default QuestionsAndAnswersSection;
